import styled from "styled-components";

export const InputFieldCss = styled.div`
  text-align: left;
  padding: 0;
  width: 100%;
  min-width: 200px;
  label.input__textfield {
    font-size: 14px;
    font-weight: 500;
    color: #131313;
    .common__required {
      color: #ff0c0c;
    }
  }
  .small-input {
  width: 57%;
  }
  .common__upload_button {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .common__inputField__error {
    color: #ff0c0c;
  }
  .common__format {
    color: #00a4e5;
    font-size: 14px;
    line-height: 17.64px;
  }
  .common__span {
    padding: 5px 0px 0px 0px;
    font-size: 12px;
  }
  .common__upload_span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  } 
  .input-container {
    display: flex;
    align-items: center;
    border: 1px solid #ebedf2;
    border-radius: 6px;
  }

  .currency-symbol {
    background: #f0f0f0;
    padding: 7px 8px;
    border-radius: 5px 0 0 5px;
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
    ::-webkit-calendar-picker-indicator {
        filter: invert(1);
    }
`;
